<template>
  <div class="crops-grid">
    <ul :class="{'isFiltered': (filCrop != '')}">
      <li v-for="crop in mycrops" :key="crop.id" :class="{'isActive': (filCrop != '' && filCrop == crop.id)}">
        <a @click="checkThisCrop(crop.id)">
          <img :src="getMyUrl(crop.logo_name)" alt="" :title="crop.name">
          <span>{{gheomsThisCrop(crop.id)}}</span>
        </a>
      </li>
      <li class="closer" v-if="filCrop != '' && mycrops.length > 1" >
        <a @click="resetFilteredCrops()">
          <i class="icon-bc-cross-raw"></i>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "",
  props: [
    "mycrops", "mygheoms", "filCrop"
  ],
  data:function(){ 
    return {
      default_url: "/crop/pic/tblack/"
    }
  },
  methods: {
   getMyUrl(crop) {
     return this.default_url + crop
   },

   resetFilteredCrops() {
     this.$emit('filterthiscrop', "");
   },

   checkThisCrop(crop) {
     console.log("check!");
     this.$emit('filterthiscrop', crop);
   },

   gheomsThisCrop(idCrop) {
     return this.mygheoms.filter(gheom => gheom.crop_id == idCrop).length 
   }
  }
}
</script>

<style scoped>
  ul {
    display: grid;
    grid-template-columns: repeat(4, minmax(64px, 1fr));
    grid-gap: 0.5rem;
    padding: 0;
    margin-top: 2rem;
  }

  @media screen and (min-width: 1024px) {
    ul {
      padding-left: 2rem;
      grid-template-columns: repeat(auto-fill, 64px);
    }
  }

  li {
    position: relative;
  }
  a {
    position: relative;
    display: block;
  }

  span {
    position: absolute;
    top: 0.5rem;
    right: 0;
    padding: 3px 7px;
    min-width: 32px;
    text-align: center;
    border-radius: 20px;
    font-size: 0.75rem;
    line-height: 0.75rem;
    color: #ffffff;
  }

  img {
    width: 64px;
  }
</style>